namespace Gamification.Gamification {
    export interface UtentiDatiRow {
        IdUtenteDati?: number;
        UserId?: number;
        TenantId?: number;
        IdAzienda?: number;
        Cognome?: string;
        Nome?: string;
        Email?: string;
        Bloccato?: boolean;
        Api?: number[];
        UserUsername?: string;
        UserDisplayName?: string;
        UserEmail?: string;
        UserSource?: string;
        UserLastDirectoryUpdate?: string;
        UserUserImage?: string;
        UserInsertDate?: string;
        UserInsertUserId?: number;
        UserUpdateDate?: string;
        UserUpdateUserId?: number;
        UserIsActive?: number;
        UserMobilePhoneNumber?: string;
        UserMobilePhoneVerified?: boolean;
        UserTwoFactorAuth?: number;
        IdAziendaRagioneSociale?: string;
    }

    export namespace UtentiDatiRow {
        export const idProperty = 'IdUtenteDati';
        export const nameProperty = 'Cognome';
        export const localTextPrefix = 'Gamification.UtentiDati';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            IdUtenteDati = "IdUtenteDati",
            UserId = "UserId",
            TenantId = "TenantId",
            IdAzienda = "IdAzienda",
            Cognome = "Cognome",
            Nome = "Nome",
            Email = "Email",
            Bloccato = "Bloccato",
            Api = "Api",
            UserUsername = "UserUsername",
            UserDisplayName = "UserDisplayName",
            UserEmail = "UserEmail",
            UserSource = "UserSource",
            UserLastDirectoryUpdate = "UserLastDirectoryUpdate",
            UserUserImage = "UserUserImage",
            UserInsertDate = "UserInsertDate",
            UserInsertUserId = "UserInsertUserId",
            UserUpdateDate = "UserUpdateDate",
            UserUpdateUserId = "UserUpdateUserId",
            UserIsActive = "UserIsActive",
            UserMobilePhoneNumber = "UserMobilePhoneNumber",
            UserMobilePhoneVerified = "UserMobilePhoneVerified",
            UserTwoFactorAuth = "UserTwoFactorAuth",
            IdAziendaRagioneSociale = "IdAziendaRagioneSociale"
        }
    }
}
